//
// 开关
// ============================================================
import Ns from "./utility";

const Input = () => {
    new Ns({
        el: "body",
        eventHandle: [{
            type: "input",
            entrust: ".input",
            callback:  function (ev) {
                let type = ns(this).attr("type");

                if (type == "text" || type == "password") {
                    if(ns(this).val() != "") {
                        ns(this).parent().find(".input-handle").removeClass("opacity-0");
                        ns(this).parent().addClass("active");
                    } else {
                        ns(this).parent().find(".input-handle").addClass("opacity-0");
                        ns(this).parent().removeClass("active");
                    }
                }

                return true;
            }
        }, {
            type: "click",
            entrust: ".input-handle",
            callback: function (ev) {
                let type = ns(this).parents(".input-group").find(".input").attr("type");

                if (ns(this).hasClass("icon-attentionforbid")) {
                    ns(this).parents(".input-group").find(".input").attr("type", "password");
                    ns(this).addClass("icon-attention").removeClass("icon-attentionforbid")
                } else if(ns(this).hasClass("icon-attention")) {

                    ns(this).parents(".input-group").find(".input").attr("type", "text");
                    ns(this).addClass("icon-attentionforbid").removeClass("icon-attention");
                } else if (ns(this).hasClass("icon-close")) {

                    ns(this).parents(".input-group").find(".input").val("");
                    ns(this).parents(".input-group").find(".input-handle").addClass("opacity-0");
                    ns(this).parent().removeClass("active");
                }
                return true;
            }
        }],
    });

};

module.exports = Input;


// WEBPACK FOOTER //
// src/js/input.js